// export const USER = {
//     UserName: "izaantest",
//     MobileNumber: "029348293489",
//     Email: "izaantest@example.com"
// }

export const USER = {};
